export enum UserRole {
  Owner = 0,
  Admin = 1,
  Agent = 2,
  School = 3,
  Student = 4,
  Support = 5,
  ServiceProvider = 6,
  Parent = 7,
  Teacher = 8,
}
